import '../../App.css';
import '../../styles/login.css'
import { withRouter } from "react-router-dom"
import React from 'react';
import GeoAdmin from './GeoAdmin';

function DireccionModulo(props) {

    return (
        <div >
            <GeoAdmin sideBar={true} userTab={true}> </GeoAdmin>

        </div>
    );
}

export default withRouter(DireccionModulo);